import { useEffect, useState } from 'react';

import type { Tier } from '~/interfaces/subscriptions';
import type { UpgradePage } from '~/interfaces/upgrade_page';

const getPriceIdFromSortedTiers = (tiers: Tier[], tiersOrder: UpgradePage['main_section']['tiers_order']) => {
  const firstSortedTierId = tiersOrder && tiersOrder.length > 0 ? tiersOrder[0].id : undefined;

  if (!firstSortedTierId) {
    return;
  }

  if (firstSortedTierId === 'free') {
    if (tiersOrder.length === 1) {
      return;
    }

    return tiers.find((tier) => tier.id === tiersOrder[1].id)?.prices[0].id;
  }

  return tiers.find((tier) => tier.id === firstSortedTierId)?.prices[0].id;
};

const useSelectedPriceId = (mostPopularPriceId: string, tiers: Tier[], upgradePage: UpgradePage) => {
  const firstTier = tiers[0];
  const firstTierPriceId = firstTier?.prices[0]?.id;
  const [priceId, setPriceId] = useState<string>(mostPopularPriceId || firstTierPriceId || 'free');

  useEffect(() => {
    // Set the first tier as selected on page load
    if (!mostPopularPriceId && tiers.length > 0 && tiers[0].prices.length > 0 && upgradePage?.main_section) {
      const mainSection = upgradePage.main_section;
      const priceIdFromSortedTiers = getPriceIdFromSortedTiers(tiers, mainSection.tiers_order);

      if (priceIdFromSortedTiers) {
        setPriceId(priceIdFromSortedTiers);
      } else {
        setPriceId(tiers[0].prices[0].id);
      }
    }
  }, [tiers, mostPopularPriceId, upgradePage.main_section.tiers_order, upgradePage.main_section]);

  return {
    priceId,
    setPriceId,
  };
};

export default useSelectedPriceId;
